//@flow
//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import 'moment/locale/pt-br';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import { objectsConstants } from '../../_constants/objects.constants';
import { translate } from '../../_helpers/messages.helper';
import { defaultService } from '../../_services/defaultService';
import { prontuarioService } from '../../_services/prontuario.service';
import { prontuarioReceituarioService } from '../../_services/prontuarioReceituario.service';
import { protocoloAtendimentoService } from '../../_services/protocoloAtendimento.service';
import MedicamentoFormula from '../../components/MedicamentoFormula/MedicamentoFormula';
import MedicamentoPrescrito from '../../components/MedicamentoPrescrito/MedicamentoPrescrito';
import ModalImpressao from '../../components/Modal/ModalImpressao';
import { ModalProtocolo } from '../../components/Modal/ModalProtocolo';
import ReceituarioExamesOutros from '../../components/ReceituarioExamesOutros/ReceituarioExamesOutros';
import FormSelectInput from '../../components/inputs/FormSelectInput';
import InputViewEdit from '../../components/inputs/InputViewEdit';

type Props = {
  nome?: string,
  callbackOnSave?: any,
};

type State = {
  id?: number,
  modalImpressao: boolean,
};

const ReceituarioValidate = Yup.object().shape({
  //   nome: Yup.string()
  //     .min(10, 'Nome muito curto!')
  //     .max(60, 'Nome muito grande!')
  //     .required('Obrigatório'),
  //   cpfCnpj: Yup.string().required('Obrigatório'),
  //   dataNascimento: Yup.date().required('Obrigatório'),
  //   email: Yup.string().required('Obrigatório').email('Email inválido'),
});

const defaultArrayItem = [
  { idList: new Date().getTime(), type: objectsConstants.TIPO_MEDICAMENTO },
];
const defaultEntity = {
  listReceituarioItem: defaultArrayItem,
};

class AnamneseReceituarioForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      entity: defaultEntity,
      modalImpressao: false,
      listaExames: [],
    };
  }

  componentDidMount() {
    const { entity, viewMode, estabelecimento } = this.props;

    if (!viewMode) {
      this.findExamesultimoMes(
        entity.paciente,
        estabelecimento
          ? estabelecimento
          : _.get(entity, 'marcacao.estabelecimento')
      );
    }
  }

  findExamesultimoMes(paciente, estabelecimento) {
    prontuarioService
      .findListaExames(_.get(paciente, 'id'), _.get(estabelecimento, 'id'))
      .then(
        (response) => {
          this.setState({
            listaExames: response.data,
          });
        },
        () => {
          console.log('Não foi possivel lista de exames dos ultimos dias');
        }
      );
  }

  toggleModalImpressao = () => {
    this.setState(({ modalImpressao }) => ({
      modalImpressao: !modalImpressao,
    }));
  };

  addItemInArray = (propName, defaultValue, values, setValues) => {
    let newValues = _.cloneDeep(values);
    // console.log(_.get(newValues, propName));
    if (!_.get(newValues, propName)) {
      _.set(newValues, propName, []);
    }
    newValues[propName].push(defaultValue ? defaultValue : {});
    setValues(newValues);
  };

  removeItemInArray = (propName, indexItem, values, setValues) => {
    let newValues = _.cloneDeep(values);
    if (newValues[propName].length > 0) {
      newValues[propName].splice(indexItem, 1);
      setValues(newValues);
    }
  };

  setValuesImprimir = (value) => {
    console.log('setValuesImprimir');
    console.log(value);
  };

  saveForm = () => {
    let { callbackOnSave, entity } = this.props;
    let _this = this;
    let values = _this.formRef.state.values;
    _.unset(values, 'protocolo');
    let promise = new Promise(function (resolve) {
      _this.formRef.validateForm(values).then((error) => {
        if (_.isEmpty(error)) {
          _this.props.loading(true);
          if (!values.prontuario) {
            values.prontuario = entity;
          }
          prontuarioReceituarioService.doSave(values).then(
            (response) => {
              _this.props.success({
                message: `Receituário, foi salvo com sucesso!`,
              });
              let id = values.id
                ? values.id
                : defaultService.getIdFromUrl(response.headers.location);
              values.id = id;
              _.unset(values, 'prontuario');
              entity.receituario = values;
              _this.props.loading(false);
              if (callbackOnSave) {
                callbackOnSave(entity);
              }
              resolve(true);
            },
            (erros) => {
              _this.props.loading(false);
              _this.props.error({
                message: 'Não foi possível salvar receituário.',
              });
              try {
                let response = erros.response.data;
                if (response && response.messages) {
                  for (var i = 0; i < response.messages.length; i++) {
                    let erroItem = response.messages[i];
                    _this.formRef.setFieldError(
                      erroItem.fieldName,
                      translate(erroItem.message.code)
                    );
                  }
                }
              } catch (error) {
                console.log(error);
              }
              console.log(erros);
            }
          );
        } else {
          resolve(false);
        }
      });
    });
    return promise;
  };

  getReceituarioItem = (
    values,
    index,
    viewMode,
    setFieldValue,
    setValues,
    errors,
    receituarioItem,
    handleChange
  ) => {
    if (receituarioItem.type === objectsConstants.TIPO_MEDICAMENTO) {
      return (
        <MedicamentoPrescrito
          size={values.listReceituarioItem.length}
          entity={values}
          index={index}
          viewMode={viewMode}
          propName={`listReceituarioItem[${index}]`}
          onChange={setFieldValue}
          removeItem={() => {
            this.removeItemInArray(
              `listReceituarioItem`,
              index,
              values,
              setValues
            );
          }}
          errors={errors}
        ></MedicamentoPrescrito>
      );
    } else if (receituarioItem.type === objectsConstants.TIPO_FORMULA) {
      return (
        <MedicamentoFormula
          size={values.listReceituarioItem.length}
          entity={values}
          index={index}
          viewMode={viewMode}
          propName={`listReceituarioItem[${index}]`}
          onChange={setFieldValue}
          removeItem={() => {
            this.removeItemInArray(
              `listReceituarioItem`,
              index,
              values,
              setValues
            );
          }}
          errors={errors}
        ></MedicamentoFormula>
      );
    } else if (receituarioItem.type === objectsConstants.TIPO_EXAMES_OUTROS) {
      return (
        <ReceituarioExamesOutros
          size={values.listReceituarioItem.length}
          entity={values}
          index={index}
          viewMode={viewMode}
          propName={`listReceituarioItem[${index}]`}
          onChange={handleChange}
          removeItem={() => {
            this.removeItemInArray(
              `listReceituarioItem`,
              index,
              values,
              setValues
            );
          }}
          errors={errors}
        ></ReceituarioExamesOutros>
      );
    }
  };
  toggleProtocolo = () => {
    this.setState(({ openProtocol }) => ({ openProtocol: !openProtocol }));
  };
  render() {
    let _this = this;
    const { viewMode, paciente, entity, ...otherProps } = this.props;
    const { listaExames } = this.state;
    let receituario = _.get(entity, 'receituario');

    return (
      <React.Fragment>
        <Formik
          validationSchema={ReceituarioValidate}
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={_.isEmpty(receituario) ? {} : receituario}
          ref={(form) => {
            this.formRef = form;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            validationSchema,
            validateForm,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="receituario">
                <div className={`form-row ${viewMode ? 'd-none' : ' '}`}>
                  <div className="col-12 mt-2">
                    <label>
                      Exames em aberto ou solicitados nos últimos 30 dias{' '}
                    </label>
                    <p className="ml-2 small">
                      {listaExames &&
                        listaExames.map((exameSolicitado, index) => {
                          return (
                            <span key={index}>
                              {exameSolicitado.nome}{' '}
                              {index + 1 < listaExames.length ? ' • ' : ''}
                            </span>
                          );
                        })}
                    </p>
                  </div>
                  <hr></hr>
                  <div className="col-12 mt-2">
                    <InputViewEdit
                      label=""
                      placeholder="Selecione um protocolo já salvo para o receituário"
                      component={FormSelectInput}
                      service={protocoloAtendimentoService.findByMedico}
                      labelKey={'nome'}
                      valueKey={'id'}
                      returnFullObject={true}
                      defaultValue={_.get(values, `protocolo`, '--')}
                      required={false}
                      value={_.get(values, `protocolo`)}
                      name={`protocolo`}
                      viewMode={viewMode}
                      id={`protocolo`}
                      onChange={(name, value) => {
                        this.props.loading(true);
                        protocoloAtendimentoService
                          .getReceituario(value.id)
                          .then(
                            (response) => {
                              let receituario = response.data.data;
                              if (receituario) {
                                receituario.id = null;
                                receituario.protocolo = value;
                                setValues(receituario);
                              } else {
                                setValues({});
                              }

                              this.props.loading(false);
                            },
                            (error) => {
                              console.log(error);
                              this.props.loading(false);
                            }
                          );
                      }}
                    />
                  </div>
                </div>
                <div className={`form-row ${viewMode ? 'd-none' : ' d-flex '}`}>
                  <div className="d-flex receituario-label-buttons">
                    <label>Adicionar ao receituário</label>
                  </div>
                  <div className="receituario-buttons d-flex flex-column flex-lg-row justify-content-center w-100">
                    <button
                      type="button"
                      className="btn btn-light-blue"
                      onClick={() =>
                        this.addItemInArray(
                          'listReceituarioItem',
                          { type: objectsConstants.TIPO_FORMULA },
                          values,
                          setValues,
                          handleChange
                        )
                      }
                    >
                      Fórmula
                    </button>
                    <button
                      type="button"
                      className="btn btn-light-blue"
                      onClick={() =>
                        this.addItemInArray(
                          'listReceituarioItem',
                          { type: objectsConstants.TIPO_MEDICAMENTO },
                          values,
                          setValues
                        )
                      }
                    >
                      Médicamento
                    </button>
                    <button
                      type="button"
                      className="btn btn-light-blue"
                      onClick={() =>
                        this.addItemInArray(
                          'listReceituarioItem',
                          { type: objectsConstants.TIPO_EXAMES_OUTROS },
                          values,
                          setValues
                        )
                      }
                    >
                      Exames ou outros
                    </button>
                  </div>
                </div>
                {/* <hr></hr> */}

                {/* MAP de medicamentos prescritos */}
                <div className="receituario-content">
                  {(!values.listReceituarioItem ||
                    values.listReceituarioItem.length === 0) && (
                    <p className="receituario-info">
                      Nenhum item cadastrado no receitário, adicione um item
                      acima ou inicie por um protocolo
                    </p>
                  )}
                  {values.listReceituarioItem &&
                    values.listReceituarioItem.map((receituarioItem, index) => {
                      return (
                        <React.Fragment
                          key={
                            receituarioItem && receituarioItem.id
                              ? receituarioItem.id
                              : index
                          }
                        >
                          {this.getReceituarioItem(
                            values,
                            index,
                            viewMode,
                            setFieldValue,
                            setValues,
                            errors,
                            receituarioItem,
                            handleChange
                          )}
                        </React.Fragment>
                      );
                    })}

                  <ModalProtocolo
                    ref={(protocol) => (this._protocolInput = protocol)}
                    name="listprotocol"
                    toogle={this.toggleProtocolo}
                    isOpen={this.state.openProtocol}
                    target={'protocol'}
                    user={this.props.user}
                    entity={values}
                    callbackOnSave={(savedEntity) => setValues(savedEntity)}
                    {...otherProps}
                  />
                </div>
                {values.id && (
                  <div
                    className={`form-row d-flex buttons-bottom
                  ${
                    !values.protocoloAtendimentoReceituario
                      ? 'justify-content-between'
                      : 'justify-content-end'
                  }`}
                  >
                    {/* {!values.protocoloAtendimentoReceituario && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.toggleProtocolo}
                      >
                        Salvar como protocolo
                      </button>
                    )}*/}
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={this.toggleModalImpressao}
                    >
                      <span className="icon-btn-imprimir"></span>
                      Imprimir
                    </button>
                    {this.state.modalImpressao && (
                      <ModalImpressao
                        title="Impressão receituário"
                        toogle={this.toggleModalImpressao}
                        isOpen={this.state.modalImpressao}
                        target={'impressao'}
                        getItem={this.getReceituarioItem}
                        entity={values}
                        marcacao={entity.marcacao}
                        onCancel={this.toggleModalImpressao}
                        callbackOnSave={(valuesPrint) =>
                          this.setValuesImprimir(valuesPrint)
                        }
                        {...otherProps}
                      ></ModalImpressao>
                    )}
                  </div>
                )}
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(AnamneseReceituarioForm);
